module.exports = __webpack_public_path__ + "static/img/data1.9250fc74.png";